/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const e = e => t => "function" == typeof t ? ((e, t) => (window.customElements.define(e, t), t))(e, t) : ((e, t) => {
    const {
      kind: n,
      elements: r
    } = t;
    return {
      kind: n,
      elements: r,
      finisher(t) {
        window.customElements.define(e, t);
      }
    };
  })(e, t),
  t = (e, t) => "method" === t.kind && t.descriptor && !("value" in t.descriptor) ? Object.assign(Object.assign({}, t), {
    finisher(n) {
      n.createProperty(t.key, e);
    }
  }) : {
    kind: "field",
    key: Symbol(),
    placement: "own",
    descriptor: {},
    initializer() {
      "function" == typeof t.initializer && (this[t.key] = t.initializer.call(this));
    },
    finisher(n) {
      n.createProperty(t.key, e);
    }
  };
function n(e) {
  return (n, r) => void 0 !== r ? ((e, t, n) => {
    t.constructor.createProperty(n, e);
  })(e, n, r) : t(e, n);
}
function r(e) {
  return n({
    attribute: !1,
    hasChanged: null == e ? void 0 : e.hasChanged
  });
}
const o = e => r(e);
function i(e, t) {
  return (n, r) => {
    const o = {
      get() {
        return this.renderRoot.querySelector(e);
      },
      enumerable: !0,
      configurable: !0
    };
    if (t) {
      const t = void 0 !== r ? r : n.key,
        i = "symbol" == typeof t ? Symbol() : `__${t}`;
      o.get = function () {
        return void 0 === this[i] && (this[i] = this.renderRoot.querySelector(e)), this[i];
      };
    }
    return void 0 !== r ? a(o, n, r) : u(o, n);
  };
}
function s(e) {
  return (t, n) => {
    const r = {
      async get() {
        return await this.updateComplete, this.renderRoot.querySelector(e);
      },
      enumerable: !0,
      configurable: !0
    };
    return void 0 !== n ? a(r, t, n) : u(r, t);
  };
}
function c(e) {
  return (t, n) => {
    const r = {
      get() {
        return this.renderRoot.querySelectorAll(e);
      },
      enumerable: !0,
      configurable: !0
    };
    return void 0 !== n ? a(r, t, n) : u(r, t);
  };
}
const a = (e, t, n) => {
    Object.defineProperty(t, n, e);
  },
  u = (e, t) => ({
    kind: "method",
    placement: "prototype",
    key: t.key,
    descriptor: e
  });
function l(e) {
  return (t, n) => void 0 !== n ? ((e, t, n) => {
    Object.assign(t[n], e);
  })(e, t, n) : ((e, t) => Object.assign(Object.assign({}, t), {
    finisher(n) {
      Object.assign(n.prototype[t.key], e);
    }
  }))(e, t);
}
const d = Element.prototype,
  f = d.msMatchesSelector || d.webkitMatchesSelector;
function y(e = "", t = !1, n = "") {
  return (r, o) => {
    const i = {
      get() {
        const r = "slot" + (e ? `[name=${e}]` : ":not([name])"),
          o = this.renderRoot.querySelector(r);
        let i = o && o.assignedNodes({
          flatten: t
        });
        return i && n && (i = i.filter(e => e.nodeType === Node.ELEMENT_NODE && (e.matches ? e.matches(n) : f.call(e, n)))), i;
      },
      enumerable: !0,
      configurable: !0
    };
    return void 0 !== o ? a(i, r, o) : u(i, r);
  };
}
export { i as a, c as b, e as c, s as d, l as e, r as i, n as p, y as q, o as s };
